import React, { useState, useMemo } from "react";
import { X, Plus, Minus, ShoppingBag, Sparkles, MessageSquare, Star, ChevronDown, ChevronUp, Package } from "lucide-react";

const CATEGORIES = [
  {
    id: "decor", name: "Decor Boosters", tag: "Most Popular", icon: "\ud83c\udf88",
    items: [
      { id: "led_hbd", name: 'LED "Happy Birthday" Neon', price: 799, lead_days: 3, img: "https://images.unsplash.com/photo-1635778302434-07bbc7ba3dc7?w=200&q=60" },
      { id: "led_name", name: "Customized Name LED", price: 1499, lead_days: 3, img: "https://images.unsplash.com/photo-1631025276172-ed04db772377?w=200&q=60" },
      { id: "balloons_100", name: "Extra 100 Balloons", price: 499, img: "https://images.pexels.com/photos/414706/pexels-photo-414706.jpeg?auto=compress&w=200" },
      { id: "balloons_chrome", name: "Premium Balloon Colors (Chrome/Pastel)", price: 699, img: "https://images.unsplash.com/photo-1707589338174-dc1ddc18945a?w=200&q=60" },
      { id: "balloon_ceiling", name: "Balloon Ceiling Decoration", price: 999, img: "https://images.pexels.com/photos/7180205/pexels-photo-7180205.jpeg?auto=compress&w=200" },
      { id: "balloon_gate", name: "Entrance Balloon Gate", price: 1499, img: "https://images.unsplash.com/photo-1748813793060-6188fb01a8cd?w=200&q=60" },
    ]
  },
  {
    id: "cake", name: "Cake & Sweet Add-ons", icon: "\ud83c\udf82",
    items: [
      { id: "cake_designer", name: "1 Kg Designer Cake", price: 1200, lead_days: 1, note: "onwards", img: "https://images.unsplash.com/photo-1604413191066-4dd20bedf486?w=200&q=60" },
      { id: "cake_photo", name: "Photo Cake", price: 1500, lead_days: 1, img: "https://images.pexels.com/photos/1359294/pexels-photo-1359294.jpeg?auto=compress&w=200" },
      { id: "cupcakes", name: "Cupcake Set (6 pcs)", price: 600, lead_days: 1, img: "https://images.pexels.com/photos/1857157/pexels-photo-1857157.jpeg?auto=compress&w=200" },
      { id: "cake_styling", name: "Cake Table Premium Styling", price: 799, img: "https://images.unsplash.com/photo-1653469742883-c47111ae3bc4?w=200&q=60" },
    ]
  },
  {
    id: "capture", name: "Capture the Moment", icon: "\ud83d\udcf8",
    items: [
      { id: "photographer", name: "Photographer (2 hours)", price: 2500, img: "https://images.pexels.com/photos/13521541/pexels-photo-13521541.jpeg?auto=compress&w=200" },
      { id: "videography", name: "Videography", price: 3500, img: "https://images.pexels.com/photos/3419717/pexels-photo-3419717.jpeg?auto=compress&w=200" },
      { id: "polaroid", name: "Instant Polaroid Photos", price: 1499, img: "https://images.pexels.com/photos/3419719/pexels-photo-3419719.jpeg?auto=compress&w=200" },
    ]
  },
  {
    id: "entertainment", name: "Entertainment Add-ons", icon: "\ud83c\udfad",
    items: [
      { id: "anchor", name: "Game Host / Anchor", price: 2000, img: "https://images.pexels.com/photos/27698729/pexels-photo-27698729.jpeg?auto=compress&w=200" },
      { id: "magician", name: "Magician (Kids Special)", price: 3000, img: "https://images.unsplash.com/photo-1537627856721-321efceec2a2?w=200&q=60" },
      { id: "face_paint", name: "Face Painting Artist", price: 2000, img: "https://images.pexels.com/photos/8385028/pexels-photo-8385028.jpeg?auto=compress&w=200" },
      { id: "balloon_twister", name: "Balloon Twister", price: 1500, img: "https://images.unsplash.com/photo-1694083884221-d23d8b1a83b5?w=200&q=60" },
    ]
  },
  {
    id: "food", name: "Food & Party Essentials", icon: "\ud83c\udf7d\ufe0f",
    items: [
      { id: "catering_veg", name: "Catering (Veg)", price: 400, unit: "/plate", note: "Min 20 plates", img: "https://images.unsplash.com/photo-1763553113344-b6a32fcd9ffa?w=200&q=60" },
      { id: "live_counter", name: "Live Counter (Popcorn/Chaat)", price: 3000, note: "onwards", img: "https://images.pexels.com/photos/7014635/pexels-photo-7014635.jpeg?auto=compress&w=200" },
      { id: "party_kit", name: "Disposable Party Kit (Plates, Glass, Caps)", price: 499, img: "https://images.pexels.com/photos/33311447/pexels-photo-33311447.jpeg?auto=compress&w=200" },
    ]
  },
  {
    id: "special", name: "Special Experience", icon: "\ud83c\udf81",
    items: [
      { id: "surprise_entry", name: "Surprise Entry Setup (Blindfold/Reveal)", price: 999, img: "https://images.pexels.com/photos/17823866/pexels-photo-17823866.jpeg?auto=compress&w=200" },
      { id: "confetti_blast", name: "Confetti Blast Moment", price: 799, img: "https://images.pexels.com/photos/4303031/pexels-photo-4303031.jpeg?auto=compress&w=200" },
      { id: "sparkle_candle", name: "Sparkle Candle Entry", price: 499, img: "https://images.pexels.com/photos/1729808/pexels-photo-1729808.jpeg?auto=compress&w=200" },
      { id: "return_gifts", name: "Return Gift Packs (Kids)", price: 150, unit: "/kid", img: "https://images.pexels.com/photos/7648227/pexels-photo-7648227.jpeg?auto=compress&w=200" },
    ]
  }
];

const COMBOS = [
  {
    id: "popular_combo", name: "Most Popular Combo", price: 2499, tag: "Best Value",
    items: ["led_hbd", "balloons_100", "cake_styling"],
    color: "from-[#E83E8C] to-[#FF9F1C]"
  },
  {
    id: "birthday_combo", name: "Birthday Combo", price: 3999, tag: "Top Seller",
    items: ["cake_designer", "led_name", "confetti_blast"],
    color: "from-[#7C3AED] to-[#E83E8C]"
  },
  {
    id: "memory_combo", name: "Memory Combo", price: 4999, tag: "Premium",
    items: ["photographer", "polaroid", "cake_styling"],
    color: "from-[#0891B2] to-[#7C3AED]"
  }
];

const allItems = CATEGORIES.flatMap(c => c.items);
const getItem = (id) => allItems.find(i => i.id === id);

const AddOnPopup = ({ isOpen, onClose, onConfirm, selectedPackage, packagePrice, eventDate }) => {
  const [selections, setSelections] = useState({});
  const [expandedCat, setExpandedCat] = useState("decor");
  const [selectedCombo, setSelectedCombo] = useState(null);

  // Calculate days until event for lead time validation
  const daysUntilEvent = useMemo(() => {
    if (!eventDate) return 999;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const event = new Date(eventDate);
    event.setHours(0, 0, 0, 0);
    return Math.ceil((event - today) / (1000 * 60 * 60 * 24));
  }, [eventDate]);

  const isItemBlocked = (item) => {
    if (!item.lead_days) return false;
    return daysUntilEvent < item.lead_days;
  };

  const addOnsTotal = useMemo(() => {
    if (selectedCombo) {
      const combo = COMBOS.find(c => c.id === selectedCombo);
      return combo ? combo.price : 0;
    }
    return Object.entries(selections).reduce((sum, [id, sel]) => {
      const item = getItem(id);
      return sum + (item ? item.price * sel.quantity : 0);
    }, 0);
  }, [selections, selectedCombo]);

  if (!isOpen) return null;

  const updateQty = (id, delta) => {
    setSelectedCombo(null);
    setSelections(prev => {
      const cur = prev[id] || { quantity: 0, custom_note: "" };
      const qty = Math.max(0, Math.min(20, cur.quantity + delta));
      if (qty === 0) { const { [id]: _, ...rest } = prev; return rest; }
      return { ...prev, [id]: { ...cur, quantity: qty } };
    });
  };

  const updateNote = (id, note) => {
    setSelections(prev => ({ ...prev, [id]: { ...(prev[id] || { quantity: 1, custom_note: "" }), custom_note: note } }));
  };

  const selectCombo = (combo) => {
    setSelectedCombo(combo.id);
    const newSel = {};
    combo.items.forEach(itemId => { newSel[itemId] = { quantity: 1, custom_note: "" }; });
    setSelections(newSel);
  };

  const selectedCount = Object.values(selections).filter(s => s.quantity > 0).length;

  const handleConfirm = () => {
    const addOns = Object.entries(selections)
      .filter(([_, sel]) => sel.quantity > 0)
      .map(([id, sel]) => {
        const item = getItem(id);
        const price = selectedCombo ? Math.round(COMBOS.find(c => c.id === selectedCombo).price / Object.keys(selections).length) : item.price;
        return { id, name: item.name, price, quantity: sel.quantity, custom_note: sel.custom_note };
      });
    onConfirm(addOns);
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 z-[60]" data-testid="addon-popup">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#E83E8C] to-[#FF9F1C] px-5 py-4 flex items-center justify-between shrink-0">
          <div>
            <h2 className="text-white font-bold text-lg">Enhance Your Celebration</h2>
            <p className="text-white/80 text-xs mt-0.5">Optional add-ons for your {selectedPackage} package</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white/20 rounded-full" data-testid="addon-close-btn"><X size={20} className="text-white" /></button>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto flex-1">
          {/* Combos Section */}
          <div className="px-4 pt-4 pb-2">
            <div className="flex items-center gap-2 mb-3">
              <Star size={16} className="text-[#FF9F1C]" />
              <h3 className="font-bold text-sm text-[#1E1B4B]">Most Chosen Combos</h3>
              <span className="text-[10px] bg-[#FF9F1C]/10 text-[#FF9F1C] px-2 py-0.5 rounded-full font-semibold">SAVE MORE</span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
              {COMBOS.map(combo => (
                <button key={combo.id} onClick={() => selectCombo(combo)}
                  className={`rounded-2xl p-3 border-2 text-left transition-all ${selectedCombo === combo.id ? 'border-[#E83E8C] ring-2 ring-[#E83E8C]/20' : 'border-gray-100 hover:border-gray-200'}`}
                  data-testid={`combo-${combo.id}`}>
                  <div className="flex items-center justify-between mb-1.5">
                    <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded-full text-white bg-gradient-to-r ${combo.color}`}>{combo.tag}</span>
                    <span className="text-sm font-bold text-[#E83E8C]">Rs {combo.price.toLocaleString()}</span>
                  </div>
                  <p className="font-semibold text-xs text-[#1E1B4B] mb-1">{combo.name}</p>
                  <div className="space-y-0.5">
                    {combo.items.map(itemId => {
                      const item = getItem(itemId);
                      return item ? <p key={itemId} className="text-[10px] text-[#475569] flex items-center gap-1"><span className="text-[#25D366]">&#10003;</span> {item.name}</p> : null;
                    })}
                  </div>
                </button>
              ))}
            </div>
          </div>

          <div className="px-4 py-2">
            <div className="flex items-center gap-2 text-xs text-[#94a3b8]"><div className="flex-1 h-px bg-gray-200" /><span>or pick individual add-ons</span><div className="flex-1 h-px bg-gray-200" /></div>
          </div>

          {/* Categories */}
          <div className="px-4 pb-4 space-y-2">
            {CATEGORIES.map(cat => {
              const isExpanded = expandedCat === cat.id;
              const catSelectedCount = cat.items.filter(i => selections[i.id]?.quantity > 0).length;
              return (
                <div key={cat.id} className="rounded-2xl border border-gray-100 overflow-hidden" data-testid={`cat-${cat.id}`}>
                  <button onClick={() => setExpandedCat(isExpanded ? null : cat.id)}
                    className="w-full flex items-center justify-between px-4 py-3 hover:bg-[#FFFAF5] transition-colors">
                    <div className="flex items-center gap-2.5">
                      <span className="text-lg">{cat.icon}</span>
                      <span className="font-semibold text-sm text-[#1E1B4B]">{cat.name}</span>
                      {cat.tag && <span className="text-[9px] bg-[#E83E8C]/10 text-[#E83E8C] px-2 py-0.5 rounded-full font-bold">{cat.tag}</span>}
                      {catSelectedCount > 0 && <span className="w-5 h-5 bg-[#E83E8C] text-white rounded-full text-[10px] font-bold flex items-center justify-center">{catSelectedCount}</span>}
                    </div>
                    {isExpanded ? <ChevronUp size={16} className="text-[#94a3b8]" /> : <ChevronDown size={16} className="text-[#94a3b8]" />}
                  </button>

                  {isExpanded && (
                    <div className="px-3 pb-3 space-y-2">
                      {cat.items.map(item => {
                        const sel = selections[item.id];
                        const isSelected = sel && sel.quantity > 0;
                        const blocked = isItemBlocked(item);
                        return (
                          <div key={item.id} className={`rounded-xl border p-2.5 transition-all flex gap-3 ${blocked ? 'border-gray-100 bg-gray-50 opacity-60' : isSelected ? 'border-[#E83E8C] bg-[#E83E8C]/5' : 'border-gray-100'}`}
                            data-testid={`addon-${item.id}`}>
                            <img src={item.img} alt={item.name} className="w-14 h-14 rounded-lg object-cover shrink-0" loading="lazy" />
                            <div className="flex-1 min-w-0">
                              <div className="flex items-start justify-between gap-2">
                                <div className="min-w-0">
                                  <p className="font-semibold text-xs text-[#1E1B4B] truncate">{item.name}</p>
                                  <p className="text-[#E83E8C] font-bold text-xs mt-0.5">
                                    Rs {item.price.toLocaleString()}{item.unit || ''} {item.note && <span className="text-[10px] font-normal text-[#94a3b8]">({item.note})</span>}
                                  </p>
                                  {blocked && (
                                    <p className="text-[10px] text-amber-600 font-medium mt-0.5">
                                      Needs {item.lead_days} day{item.lead_days > 1 ? 's' : ''} advance notice
                                    </p>
                                  )}
                                </div>
                                {blocked ? (
                                  <span className="px-2 py-1 bg-gray-200 text-gray-500 text-[10px] font-bold rounded-lg shrink-0">Unavailable</span>
                                ) : isSelected ? (
                                  <div className="flex items-center gap-1 bg-[#E83E8C]/10 rounded-lg px-0.5 shrink-0">
                                    <button onClick={() => updateQty(item.id, -1)} className="w-6 h-6 flex items-center justify-center rounded text-[#E83E8C] hover:bg-[#E83E8C]/20" data-testid={`minus-${item.id}`}><Minus size={12} /></button>
                                    <span className="w-4 text-center text-xs font-bold text-[#E83E8C]">{sel.quantity}</span>
                                    <button onClick={() => updateQty(item.id, 1)} className="w-6 h-6 flex items-center justify-center rounded text-[#E83E8C] hover:bg-[#E83E8C]/20" data-testid={`plus-${item.id}`}><Plus size={12} /></button>
                                  </div>
                                ) : (
                                  <button onClick={() => updateQty(item.id, 1)} className="px-2.5 py-1 bg-[#E83E8C] text-white text-[10px] font-bold rounded-lg hover:opacity-90 shrink-0" data-testid={`add-${item.id}`}>Add</button>
                                )}
                              </div>
                              {isSelected && (
                                <div className="mt-1.5 flex items-center gap-1.5">
                                  <MessageSquare size={10} className="text-[#94a3b8] shrink-0" />
                                  <input type="text" placeholder="Custom note (name, theme, etc.)" value={sel.custom_note || ""} onChange={(e) => updateNote(item.id, e.target.value)}
                                    className="flex-1 px-2 py-1 rounded border border-gray-200 focus:border-[#E83E8C] outline-none text-[10px]" data-testid={`note-${item.id}`} />
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Footer */}
        <div className="shrink-0 border-t bg-[#FFFAF5] px-5 py-3.5">
          {selectedCount > 0 && (
            <div className="flex items-center justify-between text-xs mb-2">
              <span className="text-[#475569]">
                {selectedCombo ? COMBOS.find(c => c.id === selectedCombo)?.name : `${selectedCount} add-on${selectedCount > 1 ? 's' : ''} selected`}
              </span>
              <span className="font-bold text-[#E83E8C]">+ Rs {addOnsTotal.toLocaleString()}</span>
            </div>
          )}
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[10px] text-[#475569]">Package + Add-ons</p>
              <p className="text-lg font-bold text-[#1E1B4B]">Rs {(packagePrice + addOnsTotal).toLocaleString()}</p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => onConfirm([])} className="px-4 py-2.5 text-[#475569] text-xs font-medium hover:bg-gray-100 rounded-xl" data-testid="addon-skip-btn">Skip Add-ons</button>
              <button onClick={handleConfirm}
                className="px-5 py-2.5 bg-gradient-to-r from-[#E83E8C] to-[#FF9F1C] text-white text-xs font-bold rounded-xl hover:opacity-90 flex items-center gap-1.5"
                data-testid="addon-confirm-btn">
                <Sparkles size={14} />
                {selectedCount > 0 ? "Continue with Add-ons" : "Continue to Payment"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOnPopup;
